module.exports = __webpack_public_path__ + "static/media/empty-star.9a8bac3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-star.svg
// module id = 121
// module chunks = 0